import { ListItem, ListItemIcon, ListItemText, Tooltip } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { CSSProperties } from '@material-ui/styles';
import React from 'react';

import { ActiveLink } from './link';

const useStyles = makeStyles((theme) => ({
  listItemExtraPadding: theme.mixins.gutters() as CSSProperties,
  minimalPadding: {
    padding: 0,
    paddingLeft: theme.spacing(),
    '& a': {
      width: '100%',
    },
  },
  resetLinkColor: {
    color: theme.palette.text.primary,
    '&:hover': {
      textDecoration: 'none',
    },
    '&:hover *': {
      color: theme.palette.primary.main,
    },
  },
  reduceIconWidth: {
    minWidth: theme.spacing(6),
  },
}));

interface Properties {
  href: string;
  icon: React.ReactElement<any>;
  title: string;
  tooltipTitle?: string;
}

export default function PageLink<T extends Properties>({ href, icon, title, tooltipTitle, ...rest }: T) {
  const classes = useStyles();

  return (
    <Tooltip placement={'right'} title={tooltipTitle !== undefined ? tooltipTitle : title}>
      <ListItem className={classes.minimalPadding} button>
        <ActiveLink className={classes.resetLinkColor} href={href} {...rest}>
          <ListItem>
            <ListItemIcon className={classes.reduceIconWidth}>{icon}</ListItemIcon>
            <ListItemText className="rtl-text-align" style={{ whiteSpace: 'nowrap' }} primary={title} />
          </ListItem>
        </ActiveLink>
      </ListItem>
    </Tooltip>
  );
}
